import React from 'react';
import { TranslatedBadge } from './translated_badge';

function Buy4For3Badge({ color }) {
    return (
        <TranslatedBadge type="buy-4-for-3" translationKey="badge-buy-4-for-3" color={color} />
    );
}

export { Buy4For3Badge };
